import actionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  getEHR: createAsyncRequestReducer(actionTypes.GET_EHR),
  getEHRs: createAsyncRequestReducer(actionTypes.GET_EHRS),
  getEHRConnectors: createAsyncRequestReducer(actionTypes.GET_EHR_CONNECTORS),
  getEHRIngestions: createAsyncRequestReducer(actionTypes.GET_EHR_INGESTIONS),
  getEHRScheduledIngestions: createAsyncRequestReducer(
    actionTypes.GET_EHR_SCHEDULED_INGESTIONS,
  ),
};

export default combineReducers(reducers);
